import { Dashboard, AdminNewBuildings } from '@/components';

export const AdminNewBuildingsPage = () => (
  <Dashboard isSearch openLogIn>
    <AdminNewBuildings />
  </Dashboard>
);
